




























import { Component, Prop, Vue } from "@/shared/node_modules/vue-property-decorator";
import { DateHelper } from "@/shared/core/helpers/dateHelper";
import { VideoSubmissionState, fmtSeconds } from "./videoSubmissionState";

@Component
export default class SubmissionVideo extends Vue {
  @Prop() state!: VideoSubmissionState;

  fmtSeconds = fmtSeconds;

  get statusLabel(): string {
    const s = this.state.submission.status;
    return s === 0 ? this.$t("Pending review").toString() : "";
  }

  formatDate(d: string): string {
    return d ? DateHelper.formatDate(new Date(d)) : "";
  }
}
